var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeEnabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 16.436C0.399902 7.59948 7.56335 0.436035 16.3999 0.436035C25.2365 0.436035 32.3999 7.59948 32.3999 16.436C32.3999 25.2726 25.2365 32.436 16.3999 32.436C7.56335 32.436 0.399902 25.2726 0.399902 16.436Z",
    fill: "#ADB3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06641 15.6029C8.06641 16.5233 8.8126 17.2695 9.73307 17.2695C11.1138 17.2695 12.2331 16.1502 12.2331 14.7695V11.4362C12.2331 10.0555 11.1138 8.9362 9.73307 8.9362C8.8126 8.9362 8.06641 9.68239 8.06641 10.6029V15.6029Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2985 19.514L19.0766 18.7973C18.8948 18.2099 18.8038 17.9163 18.8738 17.6844C18.9303 17.4967 19.0545 17.335 19.2237 17.2286C19.4329 17.0971 19.7493 17.0971 20.3822 17.0971H20.7188C22.8606 17.0971 23.9314 17.0971 24.4372 16.4631C24.495 16.3907 24.5464 16.3136 24.5909 16.2328C24.98 15.5258 24.5376 14.5733 23.6529 12.6683C22.841 10.9201 22.435 10.0461 21.6813 9.53158C21.6083 9.48177 21.5333 9.43479 21.4565 9.39076C20.6629 8.93587 19.6797 8.93587 17.7132 8.93587H17.2867C14.9043 8.93587 13.7131 8.93587 12.973 9.65298C12.2329 10.3701 12.2329 11.5243 12.2329 13.8326V14.6439C12.2329 15.857 12.2329 16.4636 12.4482 17.0187C12.6635 17.5739 13.0757 18.0303 13.9002 18.9433L17.3097 22.7187C17.3952 22.8134 17.4379 22.8608 17.4756 22.8936C17.8275 23.1998 18.3706 23.1653 18.6782 22.8173C18.7112 22.78 18.7472 22.7276 18.8193 22.6229C18.9319 22.4592 18.9883 22.3773 19.0374 22.2962C19.4769 21.5699 19.6099 20.7072 19.4086 19.8882C19.3861 19.7968 19.3569 19.7025 19.2985 19.514Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeEnabledIcon);
export default __webpack_public_path__ + "static/media/dislike-enabled-icon.a141bc24a253d91f04b499ab58fa5cf2.svg";
export { ForwardRef as ReactComponent };